import { createAsyncThunk } from '@reduxjs/toolkit';
import { callDeleteAPI, callGetAPI, callPostAPI, callPutAPI } from '../../services/axios';

export const getTemplates = createAsyncThunk(
	'getTemplates',
	async(params, { rejectWithValue }) => {
		try {
			const { type, ...newParams } = params;
			const response = await callGetAPI({ route: `hospital/template?type=${type}`, params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getTemplateDetails = createAsyncThunk(
	'getTemplateDetails',
	async(params, { rejectWithValue }) => {
		try {
			const { id, type } = params;
			const response = await callGetAPI({ route: `hospital/template/${type}/${id}` });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getTemplateById = createAsyncThunk(
	'getTemplateById',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: `hospital/template/${newParams.id}` });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const createTemplate = createAsyncThunk(
	'createTemplate',
	async(params, { rejectWithValue }) => {
		try {
			const response = await callPostAPI({ route: 'hospital/template', body: params });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const updateTemplateName = createAsyncThunk(
	'updateTemplateName',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callPutAPI({ route: 'hospital/template/update-name', body: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const updateTemplateItems = createAsyncThunk(
	'updateTemplateItems',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callPutAPI({ route: 'hospital/template/update-items', body: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const deleteTemplate = createAsyncThunk(
	'deleteTemplate',
	async(id, { rejectWithValue }) => {
		try {
			const response = await callDeleteAPI({ route: `hospital/template/${id}` });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);